import { useCallback } from 'react';

/**
 * Thin wrapper over the Vibration API. No-ops where unsupported (desktop,
 * iOS Safari) so callers never have to feature-detect. Patterns are short so
 * they read as tactile "ticks" and a celebratory "win" buzz, never as noise.
 */
export type HapticPattern = 'tick' | 'bump' | 'win';

const PATTERNS: Record<HapticPattern, number | number[]> = {
  tick: 8,
  bump: 18,
  win: [0, 40, 60, 90],
};

export function useHaptics() {
  const vibrate = useCallback((pattern: HapticPattern) => {
    if (typeof navigator === 'undefined' || typeof navigator.vibrate !== 'function') {
      return;
    }
    try {
      navigator.vibrate(PATTERNS[pattern]);
    } catch {
      /* some browsers throw if called without a user gesture — ignore */
    }
  }, []);

  return { vibrate };
}
